export const ACTIVE_ROOM_SPECIAL_BANNER = "ACTIVE_ROOM_SPECIAL_BANNER";
export const DEFAULT_ACTIVE_ROOM_SPECIAL_BANNER = { "isVisible": false, "imgUrl": "", "onClickUrl": "" };